import React, { useRef } from "react";
import "./soundwave.css";
import SineWaves from "sine-waves";
import Button from "../../_components/button/Button";
import SlideOver from "../../_components/slide_over/SlideOver";
import VisibilitySensor from "react-visibility-sensor";
import SoundWaveMobile from "./SoundWaveMobile";
const SoundWave = () => {
  const [isVisible, setIsVisible] = React.useState(false);

  const [leftWaves, setLeftWaves] = React.useState(false);
  const [rightWaves, setRightWaves] = React.useState(false);

  React.useEffect(() => {
    if (isVisible) {
      let waves = new SineWaves({
        el: document.getElementById("leftWaves"),
        speed: 7,
        ease: "SineInOut",
        wavesWidth: "100%",
        // width: changedWidth,
        width: "100%",
        height: 300,

        waves: [
          {
            timeModifier: 4,
            lineWidth: 2,
            amplitude: -50,
            wavelength: 25,
          },
          {
            timeModifier: 2,
            lineWidth: 3,
            amplitude: -70,
            wavelength: 30,
          },
          {
            timeModifier: 4,
            lineWidth: 2,
            amplitude: -120,
            wavelength: 30,
          },
          {
            timeModifier: 3,
            lineWidth: 3,
            amplitude: 140,
            wavelength: 40,
          },
          {
            timeModifier: 0.5,
            lineWidth: 3,
            amplitude: -60,
            wavelength: 60,
          },
          {
            timeModifier: 1.3,
            lineWidth: 3,
            amplitude: -40,
            wavelength: 40,
          },
          {
            timeModifier: 3,
            lineWidth: 3,
            amplitude: 110,
            wavelength: 35,
          },
          {
            timeModifier: 3.5,
            lineWidth: 2,
            amplitude: 80,
            wavelength: 60,
          },
          {
            timeModifier: 2.5,
            lineWidth: 3,
            amplitude: 139,
            wavelength: 45,
          },
        ],

        resizeEvent: function () {
          var gradient = this.ctx.createLinearGradient(0, 0, this.width, 0);
          gradient.addColorStop(0, "rgba(25, 255, 255, 0)");
          gradient.addColorStop(0.5, "rgba(255, 25, 255, 0.75)");
          gradient.addColorStop(1, "rgba(255, 255, 25, 0");

          var index = -1;
          var length = this.waves.length;
          while (++index < length) {
            this.waves[index].strokeStyle = gradient;
          }

          index = void 0;
          length = void 0;
          gradient = void 0;
        },
      });
      setLeftWaves(waves);
    } else {
      if (leftWaves) {
        leftWaves.running = false;
      }
    }
  }, [isVisible]);
  React.useEffect(() => {
    if (isVisible) {
      let waves = new SineWaves({
        el: document.getElementById("rightWaves"),

        speed: 4,

        ease: "SineInOut",

        wavesWidth: "100%",
        // width: changedWidthRight,
        width: "100%",

        height: 300,

        waves: [
          {
            timeModifier: 4,
            lineWidth: 2,
            amplitude: 90,
            wavelength: 25,
          },
          {
            timeModifier: 4,
            lineWidth: 2,
            amplitude: 100,
            wavelength: 30,
          },
          {
            timeModifier: 4,
            lineWidth: 2,
            amplitude: 95,
            wavelength: 35,
          },
          {
            timeModifier: 4,
            lineWidth: 3,
            amplitude: 85,
            wavelength: 40,
          },
          {
            timeModifier: 4,
            lineWidth: 2,
            amplitude: 80,
            wavelength: 45,
          },
          {
            timeModifier: 4,
            lineWidth: 2,
            amplitude: 75,
            wavelength: 50,
          },
        ],

        resizeEvent: function () {
          var gradient = this.ctx.createLinearGradient(0, 0, this.width, 0);
          gradient.addColorStop(1, "rgba(255, 255, 25, 0");
          gradient.addColorStop(0.5, "rgba(255, 25, 255, 0.75)");
          gradient.addColorStop(0, "rgba(25, 255, 255, 0)");

          var index = -1;
          var length = this.waves.length;
          while (++index < length) {
            this.waves[index].strokeStyle = gradient;
          }

          // Clean Up
          index = void 0;
          length = void 0;
          gradient = void 0;
        },
      });
      setRightWaves(waves);
    } else {
      if (leftWaves) {
        rightWaves.running = false;
      }
    }
  }, [isVisible]);

  const handleClick = () => {
    window.open(
      "https://www.anthemarc.com/index.php?utm_source=AnthemAV.com&utm_medium=Online&utm_campaign=Anthem%20Room%20Correction&utm_content=Redirect",
      "_blank"
    );
  };
  function onChange(isVisible) {
    setIsVisible(isVisible);
  }

  return (
    <>
      <section
        className="z-50 relative h-full hidden lg:block md:block"
        id="sound_waves"
      >
        <div
          className="bg-black py-12 px-5 md:py-20 bg-no-repeat bg-cover "
          style={{
            backgroundImage:
              "url(" +
              "https://cdn.pmlsound.com/anthem/avm90/images/avm90-arc-gradient-background-1450x2010.jpg" +
              ")",
          }}
        >
          <div className="max-w-7xl mx-auto">
            <div className="lg:flex lg:space-x-7">
              <h4 className="lg:w-2/5 text-4xl md:text-5xl lg:text-left text-center lg:text-6xl font-bold  text-white leading-snug z-50">
                The power to engineer your room
              </h4>

              <p className="lg:w-3/5 text-xl lg:text-left text-center font-light  text-white lg:mt-0 mt-10">
                At Anthem, we like to take things one step further. Rather than
                just designing a processor, we want to engineer your room. With
                the most advanced implementation of our award-winning ARC:
                Genesis room correction, professional calibration of your system
                can be achieved with the click of a button while still offering
                advanced functionality to refine the sound to your personal
                taste.
              </p>
            </div>
          </div>
          <VisibilitySensor
            onChange={onChange}
            // offset={{
            //   top: 500,
            // }}
            // delayedCall
            partialVisibility
            minTopValue={100}
          >
            <div className="max-w-screen-2xl flex md:flex w-full items-center mt-10 m-auto">
              <div className="w-1/5 md:w-1/5" id="waves-left-container">
                <canvas className="w-full" id="leftWaves"></canvas>
              </div>
              <div className="w-3/5  md:w-3/5">
                <img
                  className="w-full scale-110"
                  src="https://cdn.pmlsound.com/anthem/avm90/images/avm90-arc-gradient-unit-591x1219.png"
                />
              </div>
              <div className="w-1/5 md:w-1/5" id="waves-right-container">
                <canvas className="w-full" id="rightWaves"></canvas>
              </div>
            </div>
          </VisibilitySensor>
          <div className="max-w-7xl mx-auto mt-10">
            <div className="lg:flex lg:space-x-7 mb-10">
              <p className="lg:w-3/5 text-xl lg:text-left text-center font-light  text-white lg:mt-0 mt-10">
                Surfaces such as windows, furnishings, and the geometry of the
                walls, floor, and ceiling add unwanted resonance and coloration.
                {/* making the bass either boomy or less punchy, voices less
                natural, and the dialogue less intelligible. */}
              </p>

              <p className="lg:w-3/5 text-xl lg:text-left text-center  font-light  text-white lg:mt-0 mt-10">
                Anthem Room Correction measures each speaker's output relative
                to the listening area, then through a series of calculations,
                adjusts its output. Not only does ARC correct peaks and dips in
                a speaker's frequency response, but it also preserves the
                beneficial acoustic attributes of a room.
              </p>
            </div>
            <Button name="Learn More" handleClick={handleClick} />
          </div>
        </div>
      </section>
      <SoundWaveMobile />
    </>
  );
};

export default SoundWave;
